import {configureStore} from "@reduxjs/toolkit";
import usersReducer from '../slices/userSlices'
const store=configureStore({
    reducer:{
        sellers:usersReducer,
        auth:{},
    },
});
export default store;